<template>
  <div class="customer-information-container">
    <el-card class="box-card" shadow="hover">
      <div slot="header" class="clearfix card-header">
        <i class="el-icon-document"></i>
        <span class="header-title">Cấu hình thông tin S-Invoice</span>
      </div>

      <el-form
          :model="formData"
          :rules="rules"
          ref="formData"
          label-width="150px"
          label-position="right"
          class="customer-form"
      >
        <!-- Thông tin đăng nhập -->
        <el-divider content-position="left">
          <i class="el-icon-user"></i>
          <span style="font-weight: bold; color: #409EFF">Thông tin đăng nhập</span>
        </el-divider>

        <el-row :gutter="20">
          <el-col :span="12" :xs="24">
            <el-form-item label="Tài khoản đăng nhập" prop="username">
              <el-input
                  v-model="formData.username"
                  autocomplete="off"
                  placeholder="Nhập tài khoản đăng nhập Sinvoice"
                  maxlength="100"
                  show-word-limit
                  clearable
                  prefix-icon="el-icon-user"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Mật khẩu" prop="password">
              <el-input
                  v-model="formData.password"
                  type="password"
                  autocomplete="new-password"
                  placeholder="Nhập mật khẩu"
                  maxlength="100"
                  show-password
                  clearable
                  prefix-icon="el-icon-lock"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <!-- Thông tin công ty/tổ chức -->
        <el-divider content-position="left">
          <i class="el-icon-office-building"></i>
          <span style="font-weight: bold; color: #67C23A">Thông tin công ty/tổ chức</span>
        </el-divider>

        <el-row :gutter="20">
          <el-col :span="12" :xs="24">
            <el-form-item label="Mã số thuế" prop="taxCode">
              <el-input
                  v-model="formData.taxCode"
                  placeholder="Nhập mã số thuế"
                  maxlength="100"
                  show-word-limit
                  clearable
                  prefix-icon="el-icon-postcard"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Tên công ty/tổ chức" prop="companyName">
              <el-input
                  v-model="formData.companyName"
                  placeholder="Nhập tên công ty/tổ chức"
                  maxlength="255"
                  show-word-limit
                  clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item label="Tên ngân hàng" prop="bankName">
              <el-select
                  v-model="formData.bankName"
                  filterable
                  clearable
                  placeholder="Chọn ngân hàng"
                  style="width: 100%"
              >
                <template #label="{ label }">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <img
                            :src="bankList.find(b => b.name === label)?.logo"
                                :alt="label || 'bank-logo'"
                                style="width: 20px"
                    />
                    <span>{{ label }}</span>
                  </div>
                </template>

                <el-option
                    v-for="bank in bankListSorted"
                    :key="bank.code"
                    :label="bank.name"
                    :value="bank.name"
                >
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <img :src="bank.logo" :alt="bank.name || 'bank-logo'" style="width: 50px" />
                    <span>{{ bank.name }}</span>
                  </div>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="Số tài khoản" prop="bankAccount">
              <el-input
                  v-model="formData.bankAccount"
                  placeholder="Nhập số tài khoản"
                  maxlength="50"
                  show-word-limit
                  clearable
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12" :xs="24">
            <el-form-item label="Số điện thoại" prop="phone">
              <el-input
                  v-model="formData.phone"
                  autocomplete="off"
                  placeholder="Nhập số điện thoại"
                  maxlength="15"
                  show-word-limit
                  clearable
                  prefix-icon="el-icon-phone"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Email" prop="email">
              <el-input
                  v-model="formData.email"
                  autocomplete="off"
                  placeholder="Nhập email công ty"
                  maxlength="100"
                  show-word-limit
                  clearable
                  prefix-icon="el-icon-message"
              >
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="Địa chỉ" prop="address">
          <el-input
              v-model="formData.address"
              type="textarea"
              :rows="3"
              placeholder="Nhập địa chỉ công ty/tổ chức"
              maxlength="500"
              show-word-limit
          >
          </el-input>
        </el-form-item>
        <!-- Thông tin chứng thư số -->
        <el-divider content-position="left">
          <i class="el-icon-lock"></i>
          <span style="font-weight: bold; color: #909399">Thông tin chứng thư số</span>
        </el-divider>

        <el-form-item label="Serial chứng thư" prop="certificateSerial">
          <el-input
              v-model="formData.certificateSerial"
              type="password"
              autocomplete="new-password"
              show-password
              placeholder="Nhập serial chứng thư (nếu có)"
              maxlength="255"
              show-word-limit
              clearable
              prefix-icon="el-icon-lock"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="Ký hóa đơn" prop="usbDigitalSignature">
          <el-radio-group v-model="formData.usbDigitalSignature">
            <el-radio :label="true">Ký USB</el-radio>
            <el-radio :label="false">Ký HSM</el-radio>
          </el-radio-group>
        </el-form-item>

        <!-- Thông tin người đại diện -->
        <el-divider content-position="left">
          <i class="el-icon-s-custom"></i>
          <span style="font-weight: bold; color: #E6A23C">Thông tin người đại diện</span>
        </el-divider>

        <el-row :gutter="20">
          <el-col :span="12" :xs="24">
            <el-form-item label="Họ tên" prop="representativeName">
              <el-input
                  v-model="formData.representativeName"
                  placeholder="Nhập họ tên người đại diện"
                  maxlength="100"
                  show-word-limit
                  clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Chức vụ" prop="representativePosition">
              <el-input
                  v-model="formData.representativePosition"
                  placeholder="Nhập chức vụ"
                  maxlength="100"
                  show-word-limit
                  clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Số điện thoại" prop="representativePhone">
              <el-input
                  v-model="formData.representativePhone"
                  autocomplete="off"
                  placeholder="Nhập số điện thoại người đại diện"
                  maxlength="15"
                  show-word-limit
                  clearable
                  prefix-icon="el-icon-phone"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Email" prop="representativeEmail">
              <el-input
                  v-model="formData.representativeEmail"
                  autocomplete="off"
                  placeholder="Nhập email người đại diện"
                  maxlength="100"
                  show-word-limit
                  clearable
                  prefix-icon="el-icon-message"
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Số giấy tờ" prop="representativeDocumentNumber">
              <el-input
                  v-model="formData.representativeDocumentNumber"
                  placeholder="Nhập số giấy tờ (CMND/CCCD/Hộ chiếu)"
                  maxlength="100"
                  show-word-limit
                  clearable
              >
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Ngày sinh" prop="representativeBirthDate">
              <el-date-picker
                  v-model="formData.representativeBirthDate"
                  type="date"
                  placeholder="Chọn ngày sinh"
                  format="dd-MM-yyyy"
                  value-format="yyyy-MM-dd"
                  clearable
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- Cấu hình bổ sung -->
        <el-divider content-position="left">
          <i class="el-icon-setting"></i>
          <span style="font-weight: bold; color: #909399">Cấu hình bổ sung</span>
        </el-divider>

        <el-row :gutter="20">
          <el-col :span="12" :xs="24">
            <el-form-item label="Mẫu hóa đơn" prop="templateCode">
              <div style="display: flex; gap: 8px;">
                <el-select
                    v-model="formData.templateCode"
                    style="width: 100%"
                    @change="onInvoiceTemplateChange"
                    filterable
                    placeholder="Chọn mẫu hóa đơn"
                    clearable
                >
                  <el-option
                      v-for="opt in invoiceTemplateOptions"
                      :key="opt.value"
                      :label="opt.label"
                      :value="opt.value"
                  />
                </el-select>
                <el-tooltip content="Lấy danh sách mẫu hóa đơn" placement="top">
                  <el-button
                      type="success"
                      icon="el-icon-download"
                      :loading="loading.sync"
                      @click="handleSyncInvoiceTemplateList"
                  />
                </el-tooltip>
              </div>
            </el-form-item>
          </el-col>

          <el-col :span="12" :xs="24">
            <el-form-item label="Ký hiệu hóa đơn" prop="invoiceSeries">
              <el-select
                  v-model="formData.invoiceSeries"
                  style="width: 100%"
                  filterable
                  placeholder="Chọn ký hiệu hóa đơn"
                  clearable
              >
                <el-option
                    v-for="opt in invoiceSeriesOptions"
                    :key="opt.value"
                    :label="opt.label"
                    :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item label="Ghi chú" prop="note">
          <el-input
              v-model="formData.note"
              type="textarea"
              :rows="4"
              placeholder="Nhập ghi chú (nếu có)"
              maxlength="1000"
              show-word-limit
          >
          </el-input>
        </el-form-item>

        <!-- Nút hành động -->
        <el-form-item class="form-actions">
          <el-button
              type="primary"
              icon="el-icon-check"
              :loading="loading.submit"
              @click="submitForm"
          >
            {{ isEdit ? 'Cập nhật' : 'Lưu' }}
          </el-button>

          <el-button
              type="success"
              icon="el-icon-connection"
              :loading="loading.test"
              @click="testConnection"
          >
            Kiểm tra
          </el-button>

          <el-button
              type="warning"
              icon="el-icon-refresh"
              @click="resetForm"
          >
            Đặt lại
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import SinvoiceViettelService from "@/services/SinvoiceViettelService";
import ElectronicInvoicesService from "@/services/ElectronicInvoicesService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import {bankListSorted} from "@/constant/bankList";
import {mapApiDataToCustomerConfig} from "@/store/sinvoiceCustomerConfigStore";
import sinvoiceConfigMixin from "@/global/mixin/sinvoiceConfig.mixin";
// import {bankListSorted} from "@/constants/bankList";

export default {
  name: "CustomerInformationScreen",
  mixins: [sinvoiceConfigMixin],
  data() {
    return {
      isEdit: false,
      invoicePatternOptions: [],
      invoiceTemplateOptions: [],
      invoiceSeriesOptions: [],
      formData: {
        id: null,
        idSchool: null,
        // Thông tin đăng nhập
        username: "",
        password: "",
        // Thông tin công ty
        taxCode: "",
        companyName: "",
        bankName: "",
        bankAccount: "",
        address: "",
        phone: "",
        email: "",
        // Thông tin người đại diện
        representativeName: "",
        representativePosition: "",
        representativePhone: "",
        representativeEmail: "",
        // Thêm trường số giấy tờ và ngày sinh cho người đại diện
        representativeDocumentNumber: "",
        representativeBirthDate: null,
        // Cấu hình bổ sung
        certificateSerial: "",
        templateCode: "",
        invoiceSeries: "",
        isActive: true,
        note: "",
        usbDigitalSignature: false
      },
      rules: {
        username: [
          {required: true, message: "Tài khoản đăng nhập không được để trống", trigger: "blur"},
          {min: 3, max: 100, message: "Tài khoản phải từ 3-100 ký tự", trigger: "blur"}
        ],
        password: [
          {required: true, message: "Mật khẩu không được để trống", trigger: "blur"},
          {min: 6, max: 100, message: "Mật khẩu phải từ 6-100 ký tự", trigger: "blur"}
        ],
        taxCode: [
          {required: true, message: "Mã số thuế không được để trống", trigger: "blur"},
          { max: 100, message: "Mật khẩu phải từ 6-100 ký tự", trigger: "blur"}
        ],
        companyName: [
          {required: true, message: "Tên công ty/tổ chức không được để trống", trigger: "blur"},
          {min: 3, max: 255, message: "Tên công ty phải từ 3-255 ký tự", trigger: "blur"}
        ],
        bankName: [
          {max: 255, message: "Tên ngân hàng không vượt quá 255 ký tự", trigger: "blur"}
        ],
        bankAccount: [
          {max: 50, message: "Số tài khoản không vượt quá 50 ký tự", trigger: "blur"}
        ],
        address: [
          {required: true, message: "Địa chỉ không được để trống", trigger: "blur"},
          {min: 10, max: 500, message: "Địa chỉ phải từ 10-500 ký tự", trigger: "blur"}
        ],
        phone: [
          {required: true, message: "Số điện thoại không được để trống", trigger: "blur"},
          {pattern: /^[0-9]{10,11}$/, message: "Số điện thoại phải từ 10-11 chữ số", trigger: "blur"}
        ],
        email: [
          {required: true, message: "Email không được để trống", trigger: "blur"},
          {type: "email", message: "Email không hợp lệ", trigger: "blur"}
        ],
        representativeName: [
          {required: true, message: "Họ tên người đại diện không được để trống", trigger: "blur"},
          {min: 3, max: 100, message: "Họ tên phải từ 3-100 ký tự", trigger: "blur"}
        ],
        representativePosition: [
          {required: true, message: "Chức vụ không được để trống", trigger: "blur"}
        ],
        representativePhone: [
          {required: true, message: "Số điện thoại người đại diện không được để trống", trigger: "blur"},
          {pattern: /^[0-9]{10,11}$/, message: "Số điện thoại phải từ 10-11 chữ số", trigger: "blur"}
        ],
        representativeEmail: [
          {type: "email", message: "Email không hợp lệ", trigger: "blur"}
        ],
        representativeDocumentNumber: [
          {required: true, message: "Số giấy tờ người đại diện không được để trống", trigger: "blur"},
          {min: 3, max: 100, message: "Số giấy tờ phải từ 3-100 ký tự", trigger: "blur"}
        ],
        representativeBirthDate: [
          {required: true, message: "Ngày sinh người đại diện không được để trống", trigger: "change"}
        ],
        certificateSerial: [
          {max: 255, message: "Serial chứng thư không vượt quá 255 ký tự", trigger: "blur"}
        ],
      },
      loading: {
        submit: false,
        test: false,
        sync: false
      },
      bankListSorted,
    };
  },
  watch: {
    "formData.taxCode": {
      handler(newVal) {
        if (newVal) {
          this.loadInvoiceTemplateOptions();
        }
      },
      immediate: false
    }
  },
  created() {
    this.initScreen();
  },
  methods: {
    async initScreen() {
      await Promise.all([
        this.loadCustomerInformation()
      ]);
    },

    /**
     * Tải thông tin cấu hình đã lưu
     */
    async loadCustomerInformation() {
      try {
        const response = await SinvoiceViettelService.getCustomerInformation();

        if (response.data && response.data.data) {
          // response.data.data có thể là mảng (như payload bạn gửi) hoặc object
          let raw = response.data.data;
          if (Array.isArray(raw)) {
            raw = raw.length > 0 ? raw[0] : null;
          }

          if (!raw) {
            // Không có dữ liệu thực sự
            this.isEdit = false;
            this.$store.dispatch("sinvoiceCustomerConfigStore/clearCustomerConfig");
            return;
          }

          console.log("loaded customer raw:", raw);

          // Nếu dữ liệu cũ chứa invoiceTemplates/invoiceSerials dưới dạng mảng, giữ lại xử lý
          if ((!raw.invoiceTemplate || !raw.invoiceSerial) && Array.isArray(raw.invoiceTemplates) && raw.invoiceTemplates.length > 0) {
            raw.invoiceTemplate = raw.invoiceTemplates[0].code || "";
          }
          if ((!raw.invoiceTemplate || !raw.invoiceSerial) && Array.isArray(raw.invoiceSerials) && raw.invoiceSerials.length > 0) {
            raw.invoiceSerial = raw.invoiceSerials[0].code || "";
          }

          // Map dữ liệu qua hàm dùng chung để tái sử dụng cho toàn app
          const mapped = mapApiDataToCustomerConfig(raw);

          this.formData = {
            ...this.formData,
            ...mapped
          };

          this.$store.dispatch("sinvoiceCustomerConfigStore/setCustomerConfig", mapped);

          // Xác định isEdit: nếu có id hoặc dữ liệu trả về là thực thể -> đang ở chế độ edit
          this.isEdit = mapped.id !== null && mapped.id !== undefined;

          await this.loadInvoiceTemplateOptions();
        }
      } catch (error) {
        console.log("Chưa có thông tin cấu hình:", error);
        this.$store.dispatch("sinvoiceCustomerConfigStore/clearCustomerConfig");
      }
    },

    async loadInvoiceTemplateOptions({ showNotify = false } = {}) {
      const taxParam = (this.formData.taxCode || '').trim();
      if (!taxParam) {
        this.invoiceTemplateOptions = [];
        this.invoiceSeriesOptions = [];
        if (showNotify) {
          NotifyMessage.leftCornerNotificationWarning("Vui lòng nhập mã số thuế!");
        }
        return;
      }

      if (showNotify) {
        this.loading.sync = true;
      }

      try {
        const data = { taxCode: taxParam, invoiceType: 'all' };
        const response = await ElectronicInvoicesService.syncInvoiceTemplateList(data);
        const list = Array.isArray(response.data && response.data.data) ? response.data.data : [];

        const mapped = list
            .map(item => {
              const template = item.templateCode || item.template || item.template_code || '';
              const serial = item.invoiceSeri || item.invoiceSerial || item.serial || item.invoice_seri || item.invoice_serial || '';
              return (template || serial) ? { template: template || '', serial: serial || '' , raw: item } : null;
            })
            .filter(Boolean);

        const pairs = mapped.map(m => ({ template: m.template || '', serial: m.serial || '' }));

        const templates = Array.from(new Set(pairs.map(i => i.template))).map(t => ({ value: t, label: t || '(Mẫu mặc định)' }));
        this.invoiceTemplateOptions = templates;

        const currentTemplate = this.formData.templateCode || '';
        if (currentTemplate) {
          this.invoiceSeriesOptions = pairs.filter(i => i.template === currentTemplate).map(i => ({ value: i.serial, label: i.serial }));
        } else {
          this.invoiceSeriesOptions = [];
        }

        if (templates.length === 0 && list.length > 0) {
          const fallbackSeries = Array.from(new Set(list.map(item => item.invoiceSeri || item.invoiceSerial || item.serial || '').filter(Boolean))).map(s => ({ value: s, label: s }));
          this.invoiceSeriesOptions = fallbackSeries;
        }

        if (showNotify) {
          if (templates.length > 0 || list.length > 0) {
            NotifyMessage.leftCornerNotificationSuccess("Lấy danh sách mẫu hóa đơn thành công!");
          } else {
            NotifyMessage.leftCornerNotificationWarning("Không tìm thấy mẫu hóa đơn nào với mã số thuế đã nhập!");
          }
        }
      } catch (err) {
        console.error('Failed to load invoice templates:', err);
        if (showNotify) {
          NotifyMessage.leftCornerNotificationError("Lỗi khi lấy danh sách mẫu hóa đơn!");
        }
      } finally {
        if (showNotify) {
          this.loading.sync = false;
        }
      }
    },

    handleSyncInvoiceTemplateList() {
      this.loadInvoiceTemplateOptions({ showNotify: true });
    },

    async onInvoiceTemplateChange(value) {
      if (!value) {
        this.invoiceSeriesOptions = [];
        this.formData.invoiceSeries = '';
        return;
      }
      try {
        const data = { taxCode: this.formData.taxCode || '', invoiceType: 'all' };
        const response = await ElectronicInvoicesService.syncInvoiceTemplateList(data);
        const list = Array.isArray(response.data && response.data.data) ? response.data.data : [];
        const mapped = list
            .map(item => ({ template: item.templateCode || item.template || '', serial: item.invoiceSeri || item.invoiceSerial || item.serial || '' }))
            .filter(i => i.template && i.serial && i.template === value);
        this.invoiceSeriesOptions = mapped.map(i => ({ value: i.serial, label: i.serial }));
        if (this.invoiceSeriesOptions.length > 0) {
          if (!this.invoiceSeriesOptions.some(opt => opt.value === this.formData.invoiceSeries)) {
            this.formData.invoiceSeries = this.invoiceSeriesOptions[0].value;
          }
        } else {
          this.formData.invoiceSeries = '';
        }
      } catch (err) {
        console.error('Failed to refresh invoice series:', err);
      }
    },

    // invoice pattern related code removed

    /**
     * Gửi form
     */
    submitForm() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          // if (!this.formData.invoiceTemplate || !this.formData.invoiceSerial) {
          //   NotifyMessage.warning("Vui lòng chọn mẫu hóa đơn hợp lệ!");
          //   return false;
          // }

          this.loading.submit = true;

          try {
            const idSchool = this.$store.getters.getIdSchool;
            const dataToSave = {
              ...this.formData,
              idSchool
            };

            let response;
            if (this.isEdit) {
              response = await SinvoiceViettelService.updateCustomerInformation(dataToSave.id, dataToSave);
            } else {
              response = await SinvoiceViettelService.saveCustomerInformation(dataToSave);
            }
            console.log(response.data.status)
            if (response.data.status === 200) {
              NotifyMessage.leftCornerNotificationSuccess(
                  this.isEdit ? "Cập nhật thông tin thành công!" : "Lưu thông tin thành công!"
              );
              this.isEdit = true;
              await this.loadCustomerInformation();
            } else {
              NotifyMessage.leftCornerNotificationError(response.data.message || "Có lỗi xảy ra!");
            }
          } catch (error) {
            console.error("Error saving customer information:", error);
            NotifyMessage.leftCornerNotificationError("Lỗi khi lưu thông tin!");
          } finally {
            this.loading.submit = false;
          }
        } else {
          NotifyMessage.leftCornerNotificationWarning("Vui lòng kiểm tra lại thông tin!");
          return false;
        }
      });
    },

    /**
     * Kiểm tra kết nối
     */
    testConnection() {
      this.$refs.formData.validate(async (valid) => {
        if (valid) {
          this.loading.test = true;

          try {
            const response = await SinvoiceViettelService.testConnection({
              username: this.formData.username,
              password: this.formData.password
            });

            if (response.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess("Kết nối thành công!");
            } else {
              NotifyMessage.error(response.data.message || "Kết nối thất bại!");
            }
          } catch (error) {
            console.error("Error testing connection:", error);
            NotifyMessage.leftCornerNotificationError("Lỗi kết nối! Vui lòng kiểm tra lại thông tin.");
          } finally {
            this.loading.test = false;
          }
        } else {
          NotifyMessage.leftCornerNotificationWarning("Vui lòng điền đầy đủ thông tin để kiểm tra kết nối!");
          return false;
        }
      });
    },

    /**
     * Đặt lại form
     */
    resetForm() {
      this.$confirm("Bạn có chắc muốn đặt lại form?", "Xác nhận", {
        confirmButtonText: "Đồng ý",
        cancelButtonText: "Hủy",
        type: "warning"
      }).then(() => {
        this.$refs.formData.resetFields();
        if (this.isEdit) {
          this.loadCustomerInformation();
        }
      }).catch(() => {
        // Hủy reset
      });
    },

  }
};
</script>

<style scoped lang="scss">
.customer-information-container {
  padding: 20px;
  background: #f0f2f5;
  min-height: calc(100vh - 100px);

  .box-card {
    max-width: 1500px;
    margin: 0 auto;
    border-radius: 8px;

    .card-header {
      display: flex;
      align-items: center;
      gap: 10px;
      font-size: 18px;
      font-weight: bold;
      color: #303133;

      i {
        font-size: 24px;
        color: #409EFF;
      }

      .header-title {
        flex: 1;
      }
    }

    .customer-form {
      padding: 20px 40px;

      .el-divider {
        margin: 30px 0 20px 0;

        .el-divider__text {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 16px;

          i {
            font-size: 18px;
          }
        }
      }

      .form-hint {
        font-size: 12px;
        color: #909399;
        margin-top: 5px;
        display: block;
      }

      .invoice-list-container {
        width: 100%;
      }

      .form-actions {
        margin-top: 40px;
        padding-top: 20px;
        border-top: 1px solid #EBEEF5;

        /* Make action buttons sit on a single row and fit without horizontal scroll */
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 36px;
        flex-wrap: nowrap;
        /* remove overflow-x to avoid scrollbar; ensure buttons can shrink to fit */

        .el-button {
          /* Size to content but allow shrinking to avoid overflow */
          flex: 0 1 auto;
          min-width: 80px;
          margin: 0 12px; /* spacing between buttons */
          white-space: nowrap; /* keep label on one line */
        }
      }
    }
  }
}

// Responsive
@media (max-width: 768px) {
  .customer-information-container {
    padding: 10px;

    .box-card {
      .customer-form {
        padding: 10px 20px;

        .el-form-item {
          margin-bottom: 18px;
        }

        .form-actions {
          /* Trên thiết bị nhỏ giảm gap và giảm min-width để vừa với màn hình */
          gap: 12px;

          .el-button {
            min-width: 64px;
            margin: 0 6px;
            white-space: nowrap;
            flex: 0 1 auto;
          }
        }
      }
    }
  }

  ::v-deep .el-form-item__label {
    width: 100% !important;
    text-align: left !important;
  }

  ::v-deep .el-form-item__content {
    margin-left: 0 !important;
  }
}

// Hover effects
.box-card {
  transition: all 0.3s;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

.el-button {
  transition: all 0.3s;

  &:hover {
    transform: translateY(-2px);
  }
}
</style>

